/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecurityAnswersDto } from '../../models/security-answers-dto';

export interface SecurityAnswersSetanswerlist$Params {
  Uname?: string | null;
      body: SecurityAnswersDto
}

export function securityAnswersSetanswerlist(http: HttpClient, rootUrl: string, params: SecurityAnswersSetanswerlist$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, securityAnswersSetanswerlist.PATH, 'post');
  if (params) {
    rb.query('Uname', params.Uname, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

securityAnswersSetanswerlist.PATH = '/forgot/answerlist';
